import { useState } from "react";
import styled from "styled-components";

const Star = styled.span`
  font-size: ${({ size }) => size || "1.4rem"};
  color: ${({ filled, theme }) => (filled ? theme.colors.primary : theme.colors.lineColor)};
  cursor: ${({ readonly }) => (readonly ? "default" : "pointer")};
  transition: color 0.1s;
  user-select: none;
  line-height: 1;
`;

const Row = styled.div`
  display: flex;
  gap: 0.1rem;
  align-items: center;
`;

function StarRating({ value = 0, onChange, readonly = false, size }) {
  const [hovered, setHovered] = useState(0);

  const display = readonly ? value : (hovered || value);

  return (
    <Row>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          filled={star <= display ? 1 : 0}
          readonly={readonly ? 1 : 0}
          size={size}
          onClick={() => !readonly && onChange && onChange(star)}
          onMouseEnter={() => !readonly && setHovered(star)}
          onMouseLeave={() => !readonly && setHovered(0)}
          title={readonly ? `${value}/5` : `${star}/5`}
        >
          ★
        </Star>
      ))}
    </Row>
  );
}

export default StarRating;
